const css = `._loaderContainer_1m2ju_1 {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 50vh;
  padding: 24px;
}

._loader_1m2ju_1 {
  border: 4px solid var(--border-color);
  border-top: 4px solid var(--secondary-border-color);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: _spin_1m2ju_1 1s linear infinite;
}

@keyframes _spin_1m2ju_1 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "loaderContainer": "_loaderContainer_1m2ju_1",
  "loader": "_loader_1m2ju_1",
  "spin": "_spin_1m2ju_1"
};